import React from "react";
import { Link } from "react-router-dom";
import CartItems from "./CartItems";
import { useCart } from "../../context/CartContext";
import { Offcanvas } from "react-bootstrap";
import { ShoppingBag, X } from "lucide-react"; 

function CartCanvas({ onHide }) {
  const { cartItems, cartSummary } = useCart();

  return (
    <>
      <Offcanvas.Header className="luxury-cart-header px-4 py-4 d-flex justify-content-between align-items-center">
        <Offcanvas.Title className="luxury-cart-title d-flex align-items-center">
          YOUR BAG 
          {cartItems && cartItems.length > 0 && (
            <span className="luxury-cart-count-badge ms-2">({cartItems.length})</span>
          )}
        </Offcanvas.Title>
        
        <button 
          type="button" 
          onClick={onHide} 
          className="border-0 bg-transparent p-0 d-flex align-items-center"
          style={{ cursor: 'pointer', color: '#000' }}
        >
          <X size={24} strokeWidth={1.5} />
        </button>
      </Offcanvas.Header>

      <Offcanvas.Body className="d-flex flex-column px-4 luxury-cart-body-wrapper">
        {cartItems && cartItems.length ? (
          <>
            {/* SCROLLABLE ITEMS CANVAS */}
            <div className="luxury-cart-scroll-container flex-grow-1">
              <div className="custom-cart-items-wrapper">
                {cartItems.map((item, index) => (
                  <CartItems key={item._id || index} item={item} />
                ))}
              </div>
            </div>

            {/* FIXED EDITORIAL FOOTER OVERLAY */}
            <div className="luxury-cart-footer-wrapper pt-4 pb-3">
              <div className="d-flex justify-content-between align-items-baseline luxury-total-row mb-4">
                <span className="luxury-total-label">SUBTOTAL</span>
                <span className="luxury-total-price">₹{cartSummary?.total || 0}</span>
              </div>
              
              <p className="luxury-shipping-disclaimer-text mb-4">
                Shipping, taxes, and discounts calculated at checkout.
              </p>

              <div className="luxury-cart-action-group d-flex flex-column gap-2">
                <Link
                  to="/checkout"
                  className="luxury-checkout-btn-solid text-center d-block"
                  onClick={onHide}
                >
                  PROCEED TO CHECKOUT
                </Link>
                
                <Link
                  to="/cart"
                  className="luxury-view-cart-btn-outline text-center d-block"
                  onClick={onHide}
                >
                  VIEW SHOPPING BAG
                </Link>
              </div>
            </div>
          </>
        ) : (
          /* ULTRA-CLEAN EMPTY STATE LAYOUT */
          <div className="luxury-cart-blank-canvas d-flex flex-column align-items-center justify-content-center flex-grow-1 text-center">
            <div className="luxury-empty-icon-wrap mb-4">
              <ShoppingBag size={48} strokeWidth={1} color="#999999" />
            </div>
            <h5 className="luxury-empty-title mb-2">Your Bag is Empty</h5>
            <p className="luxury-empty-subtitle mb-4">
              Explore our latest premium arrivals and statement formulas to fill your space.
            </p>

            <Link
              to="/shop"
              className="luxury-checkout-btn-solid px-5 d-inline-block"
              onClick={onHide}
            >
              SHOP NEW ARRIVALS
            </Link>
          </div>
        )}
      </Offcanvas.Body>
    </>
  );
}

export default CartCanvas;